// extracted by mini-css-extract-plugin
module.exports = {"title":"title___3Nb4I","CustomizationsCombinationDetail":"CustomizationsCombinationDetail___3ZHz4"};